<div class="about">
  <div class="about--container">
    <div class="about--content">
      <!-- Left Side: Text Content -->
      <div class="about--text-card">
        <h2 class="about--title"> About National Health Authority</h2>

        <h3 class="about--subtitle">What is NHA?</h3>
        <p class="about--description">
          National Health Authority (NHA) is the apex body responsible for implementing India’s flagship public health insurance/assurance scheme called Ayushman Bharat Pradhan Mantri Jan Arogya Yojana (AB PM-JAY) and has been entrusted with the role of designing strategy, building technological infrastructure, and implementing the National Digital Health Mission (NDHM) to create a National Digital Health Ecosystem.
         </p>
         <p class="about--description">
          National Health Authority is the successor of the National Health Agency, which functioned as a registered society since 23rd May 2018. Pursuant to a Cabinet decision granting full functional autonomy, the National Health Agency was reconstituted as the National Health Authority on 2nd January 2019, under Gazette Notification Registered No. DL –(N) 04/0007/2003-18.
         </p>
         <p class="about--description">
          NHA has been set up to implement PM-JAY at the national level. An attached office of the Ministry of Health and Family Welfare with full functional autonomy, the NHA is governed by a Governing Board chaired by the Union Minister for Health and Family Welfare. It is headed by a Chief Executive Officer (CEO), an officer of the rank of Secretary to the Government of India, who manages its affairs. The CEO is the ex-officio Member Secretary of the Governing Board.
         </p>

        <p class="about--description">
          NHA connects data producers and data users through a trusted, policy-driven exchange network for researchers, innovators, and policymakers.
        </p>

      </div>
    </div>
  </div>
</div>
